import { CoreGlobalFooter } from '@care/navigation';
import { Grid } from '@mui/material';
import { Error404 } from '@care/react-pages';
import { useActiveTheme } from '@care/react-component-lib';
import { SeoGlobalNavbar } from '@/components/common/SeoGlobalNavbar';

interface Custom404Props {
  showGlobalNav?: boolean;
}

export default function Custom404({ showGlobalNav = true }: Custom404Props) {
  const { isEmbraceTheme } = useActiveTheme();

  return (
    <Grid container>
      {showGlobalNav && (
        <Grid item xs={12}>
          <SeoGlobalNavbar />
        </Grid>
      )}
      <Grid item xs={12} py={3} px={9}>
        <Error404 prev="/" />;
      </Grid>
      <Grid item xs={12}>
        <CoreGlobalFooter variant={isEmbraceTheme ? 'inverse' : 'default'} />
      </Grid>
    </Grid>
  );
}
